import CovidAwareness from './assets/projects/Web/covid-awareness.png'
import flipkartSeller from './assets/projects/Web/flipkart-seller.png'

// UI/UX
import StockTrainer from './assets/projects/Uiux/stock-trainer.png'
import HealthCare from './assets/projects/Uiux/healthcare.png'
import Portfolio from './assets/projects/Uiux/portfolio.png'
import AnimeStreaming from './assets/projects/Uiux/anime-streaming.png'

// App
import LPURetouched from './assets/projects/App/lpu-retouched.png'

const projects = {
    webProjects: [
        {
            id: 1,
            name: 'Covid Awareness',
            image: CovidAwareness,
            link: 'https://csefighters-covid.netlify.app/'
        },
        {
            id: 2,
            name: 'Flipkart Seller',
            image: flipkartSeller,
            link: 'https://flipkart-seller.netlify.app/'
        }
    ],
    uiuxProjects: [
        {
            id: 1,
            name: 'Stock Trainer',
            image: StockTrainer,
            link: '#'
        },
        {
            id: 2,
            name: 'HealthCare App',
            image: HealthCare,
            link: '#'
        },
        {
            id: 3,
            name: 'Portfolio',
            image: Portfolio,
            link: '#'
        },
        {
            id: 4,
            name: 'Anime Streaming',
            image: AnimeStreaming,
            link: '#'
        }
    ],
    appProjects: [
        {
            id: 1,
            name: 'LPU Retouched',
            image: LPURetouched,
            link: 'https://play.google.com/store/apps/details?id=com.lpuretouched'
        }
    ]
}

export {projects}